import DeclarationRegisterPage from './DeclarationRegisterPage';
export default function DossierPage(){return <DeclarationRegisterPage dossier/>}
